function decodeJwtPayload(token: string): unknown {
  const part = token.split('.')[1];
  if (!part) return undefined;
  const base64 = part
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(Math.ceil(part.length / 4) * 4, '=');
  try {
    return JSON.parse(atob(base64));
  } catch {
    return undefined;
  }
}

/**
 * Defence in depth: a client (browser bundle or phone app) may only ever contain the PUBLIC
 * (publishable/anon) key. A secret key or a service_role JWT there would bypass RLS for anyone
 * who opens dev tools or unpacks the app.
 */
export function assertPublicKey(key: string): void {
  if (key.startsWith('sb_secret_')) {
    throw new Error('A secret Supabase key must never be used in the browser');
  }
  const payload = decodeJwtPayload(key) as { role?: string } | undefined;
  if (payload?.role === 'service_role') {
    throw new Error('A service_role key must never be used in the browser');
  }
}
